export interface PageInfo {
  pageI: number;
  pageSize: number;
}

export interface GetAllPagesProps<TPage, TItem> {
  /** Get the items for the provided @see page. */
  getItems: (page: TPage) => TItem[];
  /** Get a page response for the provided @see pageInfo. */
  getPage: (pageInfo: PageInfo) => Promise<TPage>;
  /** Get the total number of items using the provided @see page. */
  getTotalItemCount: (page: TPage) => number;
  /** Numer of items to request per page @default 250. */
  pageSize?: number;
}

/** Get each page and join the results together into a single array. */
export async function getAllPages<TPage, TItem>({
  getItems,
  getPage,
  getTotalItemCount,
  pageSize = 250
}: GetAllPagesProps<TPage, TItem>): Promise<TItem[]> {
  const items: TItem[] = [];
  let maxPageI: number | null = null;
  for (let pageI = 0; maxPageI == null || pageI < maxPageI; ++pageI) {
    const page = await getPage({ pageI, pageSize });
    maxPageI ??= Math.ceil(getTotalItemCount(page) / pageSize);
    items.push(...getItems(page));
  }

  return items;
}
